import { IDirectionalCost } from '../../interfaces/idirectional-cost';
import { DirectionalCostType } from '../directional-cost-type';
import { DirectionalServiceCompany } from '../directional-service-company';
import { UnitOfMeasure } from '../unit-of-measure';

export class DirectionalCostBase {
  DirectionalCostId: number;
  DirectionalServiceCompanyId: number;
  DirectionalCostTypeId: number;
  UnitCost: number;
  UnitOfMeasureId: number;
  Daily: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  DirectionalCostType?: DirectionalCostType;
  DirectionalServiceCompany?: DirectionalServiceCompany;
  UnitOfMeasure?: UnitOfMeasure;

  constructor(item?: IDirectionalCost) {
    if (item) {

      this.DirectionalCostId = item.DirectionalCostId;
      this.DirectionalServiceCompanyId = item.DirectionalServiceCompanyId;
      this.DirectionalCostTypeId = item.DirectionalCostTypeId;
      this.UnitCost = item.UnitCost;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.Daily = item.Daily;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.DirectionalCostType = new DirectionalCostType(item.DirectionalCostType);
      this.DirectionalServiceCompany = new DirectionalServiceCompany(item.DirectionalServiceCompany);
      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
    }
  }
}